import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';

export default class LocationOverviewPoliciesRoute extends Route {
  @service declare router: RouterService;
  @service declare globalOverviewAccess: GlobalOverviewAccessService;

  titleToken = 'Policies';

  beforeModel(): void {
    if (!this.globalOverviewAccess.canVisitPolicies) {
      void this.router.transitionTo('unauthorized');
    }
  }
}
